import { render } from "./TopSeasonLink.vue?vue&type=template&id=653121b8&scoped=true"
import script from "./TopSeasonLink.vue?vue&type=script&lang=js"
export * from "./TopSeasonLink.vue?vue&type=script&lang=js"

import "./TopSeasonLink.scss?vue&type=style&index=0&id=653121b8&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653121b8"]])

export default __exports__